var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPurchaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.125 13.125H24.875M36.125 20.625H24.875M36.125 28.125H28.625M17.375 5.625H43.625V39.375L41.69 37.7175C41.0104 37.135 40.1448 36.8148 39.2497 36.8148C38.3546 36.8148 37.489 37.135 36.8094 37.7175L34.8744 39.375L32.9413 37.7175C32.2615 37.1345 31.3955 36.814 30.5 36.814C29.6045 36.814 28.7385 37.1345 28.0587 37.7175L26.1256 39.375L24.1906 37.7175C23.511 37.135 22.6454 36.8148 21.7503 36.8148C20.8552 36.8148 19.9896 37.135 19.31 37.7175L17.375 39.375V5.625Z",
    stroke: "#16151C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.284216,
    y1: 1.58863,
    x2: 55.2842,
    y2: 39.5886,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPurchaseIcon);
export default __webpack_public_path__ + "static/media/no-purchase-icon.1cdf5e5bfc9ae3790c26d8c168955e9b.svg";
export { ForwardRef as ReactComponent };